import React, { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=loading, false=anon, object=user
  useEffect(() => {
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false));
  }, []);
  const login = useCallback(async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    if (data.user) setUser(data.user);
    return data;
  }, []);
  const verify2fa = useCallback(async (email, code) => {
    const { data } = await api.post("/auth/verify-2fa", { email, code });
    setUser(data.user);
    return data.user;
  }, []);
  const register = useCallback(async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    setUser(data.user);
    return data.user;
  }, []);
  const logout = useCallback(async () => { await api.post("/auth/logout"); setUser(false); }, []);
  const value = useMemo(() => ({ user, setUser, login, verify2fa, register, logout }), [user, login, verify2fa, register, logout]);
  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
